<section class="astral-section-surface astral-section-surface--nested astral-section-surface--compact astral-stack-m">
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <astral-select [control]="form.controls['componentCategory']" [itemsSource]="categorySelection"></astral-select>
    <astral-select [control]="form.controls['componentTypeId']" [itemsSource]="typeSelection"></astral-select>
    <astral-input type="number" [control]="form.controls['installationYear']"></astral-input>
    <astral-input type="number" [control]="form.controls['installationMonth']"></astral-input>

    @for (property of customProperties; track property) {
      <app-object-component-property
        [forms]="form.controls['customPropertyValues']"
        [rootForm]="rootForm"
        [property]="property"
        [component]="component"
      ></app-object-component-property>
    }

    <astral-input [control]="form.controls['name']"></astral-input>
    <astral-input [span]="'full'" [control]="form.controls['comment']"></astral-input>
    @if (!parentIsNew) {
      <div class="astral-grid-full">
        <app-multi-file-upload-mini
          [fileControls]="form.controls['attachments']"
          [fileService]="componentService"
          [mimes]="mimes"
          [maxFiles]="10"
          [parentEntityId]="component?.id"
          [buttonText]="'COMMON.ATTACH_FILE'"
        ></app-multi-file-upload-mini>
      </div>
    }
  </astral-layout-group>

  <div class="astral-form-actions">
    <astral-button
      variant="secondary"
      [size]="actionButtonSize"
      type="button"
      icon="trash"
      labelKey="COMPONENT.DELETE_COMPONENT"
      (click)="delete()"
    ></astral-button>
  </div>
</section>
